import { useEffect, useRef } from "react";
import { supabase } from "./supabase";

export function useSupabasePostgresSubscription({
  channelName = "postgres", // default single name
  events = [],
}) {
  const channelRef = useRef(null);
  const eventsRef = useRef(events);
  eventsRef.current = events;

  useEffect(() => {
    if (!supabase) return;

    // Always re-use same channel name
    const channel = supabase.channel(channelName);

    eventsRef.current.forEach(({ event, table, schema = "public", filter, callback }) => {
      channel.on(
        "postgres_changes",
        { event, schema, table, filter },
        (payload) => callback?.(payload)
      );
    });

    channel.subscribe();

    channelRef.current = channel;

    return () => {
      supabase.removeChannel(channel);
    };
  }, [channelName]);

  return channelRef;
}
